import {INFO_BACKGROUND, INFO_COLOR} from "../../../../../../../themes/themeConfigurator";

const styles = (theme) => ({
  chip: {
    color: INFO_COLOR,
    background: INFO_BACKGROUND,
    fontSize: 12,
    height: 18,
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1)
    }
  }
});

export default styles;